import * as Sentry from "@sentry/nextjs"

import { useDeleteNonBookableOrderItemMutation } from "@mono/essentials/entities/order/hooks"

export const useHandleDeleteOrderItem = () => {
  const { mutateAsync: deleteNonBookableOrderItemMutation } =
    useDeleteNonBookableOrderItemMutation()

  const handleDeleteOrderItem = async ({
    orderId,
    orderItemId,
    onError,
    onSuccess,
  }: {
    orderId: string
    orderItemId: string
    onSuccess?: () => Promise<void>
    onError?: (error: unknown) => Promise<void>
  }) => {
    try {
      await deleteNonBookableOrderItemMutation({ orderId, orderItemId })
      await onSuccess?.()
    } catch (error: any) {
      Sentry.captureException(error)
      await onError?.(error)
    }
  }

  return { handleDeleteOrderItem }
}
